"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GUEST_TYPE_QUERY = exports.GET_SESSION_QUERY = void 0;
exports.GET_SESSION_QUERY = `
  query GetUserSession($token: String!) {
    getSession(token: $token) {
      jwt
      refreshToken
      user {
        id
        companyName
        email
        firstName
        lastName
        roles
        country
        regions
        companyID
        avatar
        isPowerHost
        teams {
          id
          name
        }
      }
    }
  }
`;
exports.GUEST_TYPE_QUERY = `
  query GetGuestType($email: String!, $country: String) {
    getGuestType(email: $email, country: $country) {
      isBusinessUser
      isDomainValid
      hasExistingAccount
      userId
    }
  }
`;
